import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, formData);
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Login admin realizado!');
      navigate('/admin-lembrou/backoffice');
    } catch (error) {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 rounded-3xl shadow-2xl border-0 bg-white">
        <div className="text-center mb-8">
          <img src="/icon-lembrou.jpg" alt="Lembrou?" className="w-16 h-16 mx-auto mb-4 rounded-2xl" />
          <h1 className="text-3xl font-bold text-gray-900">Admin Lembrou</h1>
          <p className="text-gray-600 mt-2">Backoffice do SaaS</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="username">Usuário</Label>
            <Input
              id="username"
              type="text"
              placeholder="admin@lembrou.com"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
              className="rounded-xl h-11"
            />
          </div>

          <div>
            <Label htmlFor="password">Senha</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              required
              className="rounded-xl h-11"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-2xl h-11 bg-gray-900 hover:bg-gray-800 text-white font-medium shadow-md"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <button
          onClick={() => navigate('/')}
          className="mt-6 text-sm text-gray-500 hover:text-gray-700 w-full text-center"
        >
          ← Voltar para início
        </button>
      </Card>
    </div>
  );
};

export default AdminLogin;
